import { render, staticRenderFns } from "./connectedSuccessfully.vue?vue&type=template&id=622e4212&lang=pug"
import script from "./connectedSuccessfully.vue?vue&type=script&lang=js"
export * from "./connectedSuccessfully.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports